module.exports = __webpack_public_path__ + "img/content_1_title.a7fdbb94.jpg";